import { makeStyles } from '@material-ui/core';

export const useSummaryStepStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(2, 0),
    },
    headerSection: {
        textAlign: 'center',
        marginBottom: theme.spacing(4),
    },
    title: {
        fontSize: '1.5rem',
        fontWeight: 600,
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(1),
    },
    subtitle: {
        fontSize: '0.875rem',
        color: theme.palette.text.secondary,
    },
    summaryCard: {
        padding: theme.spacing(2.5),
    },
    cardHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(0.5),
    },
    cardTitle: {
        fontSize: '0.875rem',
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
    statusConfigured: {
        fontSize: '0.75rem',
        fontWeight: 500,
        color: theme.palette.success.main,
    },
    statusSkipped: {
        fontSize: '0.75rem',
        fontWeight: 500,
        color: theme.palette.text.secondary,
    },
    statusNotModified: {
        fontSize: '0.75rem',
        fontWeight: 500,
        color: theme.palette.info.main,
    },
    statusModified: {
        fontSize: '0.75rem',
        fontWeight: 500,
        color: theme.palette.warning.main,
    },
    cardDetails: {
        fontSize: '0.813rem',
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(0.5),
    },
    editButton: {
        fontSize: '0.875rem',
        fontWeight: 500,
        color: theme.palette.primary.main,
        textTransform: 'none',
        padding: theme.spacing(0.5, 2),
        '&:hover': {
            backgroundColor: 'transparent',
            textDecoration: 'underline',
        },
    },
    cardsList: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
    cardContent: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
    },
    cardInfo: {
        flex: 1,
    },
}));
